export default "__VITE_ASSET__XGsb9Dun__"